import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection
} from '@angular/fire/firestore';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { Service } from '../service.model';
import { ServiceProviderType } from '../service-provider-type.enum';

@Injectable({
  providedIn: 'root'
})
export class MyServicesService {
  constructor(private firestore: AngularFirestore) {}

  public getMyServicesCollection(
    user: firebase.User
  ): AngularFirestoreCollection<Service> {
    return this.firestore.collection<Service>(`services`, service =>
      service.where('userId', '==', user.uid)
    );
  }

  public saveService(documentKey: string, service: Service): Observable<void> {
    return from(
      this.firestore
        .collection<Service>('services')
        .doc(documentKey)
        .set({ ...service })
    );
  }

  public createService(service: Service): Observable<string> {
    return from(
      this.firestore.collection<Service>('services').add({ ...service })
    ).pipe(map(ref => ref.id));
  }

  public getServiceTypeTags(
    serviceType: ServiceProviderType
  ): Observable<string[]> {
    return this.firestore
      .doc<any>(`provider-type-tags/${serviceType}`)
      .valueChanges()
      .pipe(map(doc => doc.tags));
  }
}
